
import CButtonGroup from '@/components/c-button-group'
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import {
  getIndexConfig,
  getTableConfig,
  inputList,
  isDealwith,
  isPayment,
  dealUpdate,
  syncType,
  pushOpenApi,
  updateOpenApi,
} from './config'
import { defineComponent, toRefs, reactive, onMounted } from 'vue'
import imgdialog from './component/img/index.vue'
import adjustdialog from './component/adjust/index.vue'
import newdialog from './component/new-dialog/index.vue'
import { getList, gabCarQuery, enterpriseViolationSettingQuery } from './api'
export default defineComponent({
  components: {
    CSearchList,
    CTable,
    imgdialog,
    adjustdialog,
    newdialog,
    CButtonGroup,
  },
  setup() {
    const remoteData1 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        enterpriseViolationSettingQuery({ orgName: val }).then((res) => {
          remoteData1.options = res.data.map((item) => {
            return {
              label: item.orgName,
              value: item.id,
            }
          })
        })
      },
    })
    const remoteData2 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        gabCarQuery({ carNo: val }).then((res) => {
          remoteData2.options = res.data.map((item) => {
            return {
              label: item.value,
              value: item.value,
            }
          })
        })
      },
    })
    const data = reactive({
      inputList: inputList(
        { ...toRefs(remoteData1) },
        { ...toRefs(remoteData2) }
      ),
      ...getIndexConfig(),
      isDealwith,
      isPayment,
      dealUpdate,
      syncType,
      pushOpenApi,
      updateOpenApi,
      isFlag: false,
      isAdjust: false,
      isNew: false,
      currentRow: null as any,
    })
    // 表单组件变量
    const tableConfig = reactive({
      ...getTableConfig(),
    })
    /**
     * @description:列表接口
     * @return {void}
     */
    const getListApi = () => {
      const obj = Object.assign(
        { ...data.queryForm },
        {
          currPage: tableConfig.pagination.currentPage,
          pageSize: tableConfig.pagination.pageSize,
        }
      )
      getList(obj).then((res) => {
        tableConfig.data = res.data.list
        tableConfig.pagination.total = res.data.total
      })
    }
    /**
     * @description: 重置事件
     * @param {*} val
     * @return {void}
     */
    const handleReset = (val: object) => {
      data.queryForm = val
      // getListApi()
      // console.log(val)
    }
    /**
     * @description: 查询事件
     * @param {*} params
     * @return {viod}
     */
    const handleSearch = (params: object) => {
      tableConfig.pagination.currentPage = 1
      data.queryForm = Object.assign({}, params)
      getListApi()
    }
    /**
     * @description: 翻页
     * @param {*} val  当前页数
     * @return {void}
     */
    const pageCurrentChange = (val: number) => {
      tableConfig.pagination.currentPage = val
      getListApi()
    }
    /**
     * @description: 每页条数
     * @param {*} val 数量
     * @return {void}
     */
    const pageSizeChange = (val: number) => {
      tableConfig.pagination.currentPage = 1
      tableConfig.pagination.pageSize = val
      getListApi()
    }
    onMounted(() => {
      getListApi()
    })
    const onToggle = (row, name) => {
      data[name] = !data[name]
      row && (data.currentRow = row)
    }
    const handleAction = (type: string, row: any) => {
      switch (type) {
        case '导出': {
          onToggle(row, 'isNew')
          break
        }
        case '照片': {
          onToggle(row, 'isFlag')
          break
        }
        case '修正处理状态': {
          onToggle(row, 'isAdjust')
          break
        }
      }
    }

    return {
      handleReset,
      handleSearch,
      pageCurrentChange,
      pageSizeChange,
      tableConfig,
      handleAction,
      onToggle,
      ...toRefs(data),
    }
  },
})
